import { ExclamationCircleFilled } from '@ant-design/icons';
import { Text } from "@clockout-dev/design-elements";
import styles from "../styles/login.module.scss";

export default function LoginErrorMessage({ errorMessage, error }) {
    return (
        <div
        className={`${styles.errorBanner} ${error ? styles.errorBannerVisible : ''}`}
        role="alert"
        aria-live="assertive"
        aria-hidden={!error}
    >
        <ExclamationCircleFilled className={styles.errorIcon} aria-hidden="true" />
        <Text className={styles.errorText}>
            {errorMessage || 'The email or password you entered is incorrect.'}
        </Text>
    </div>
    );
}